import { useFormContext } from 'react-hook-form'

import { CheckboxToggleInput } from '@/components/CheckboxToggleInput'
import { GEOFENCE_FIELDS } from '@/feature/observatory'

import { InfoTooltip } from '../../../InfoTooltip'

export const HighRiskField = () => {
  const { register } = useFormContext()
  return (
    <CheckboxToggleInput {...register(GEOFENCE_FIELDS.highRisk)} data-testid="geofence-high-risk">
      This is High Risk Area
      <InfoTooltip placement="bottom">
        Mark this geofence as <strong>High Risk Area</strong> if it is prone to dangers like load
        theft or poor roads.
      </InfoTooltip>
    </CheckboxToggleInput>
  )
}
